import { render, staticRenderFns } from "./CreateSender.vue?vue&type=template&id=7b8d18d0&"
import script from "./CreateSender.vue?vue&type=script&lang=ts&"
export * from "./CreateSender.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports